import debounce from "lodash.debounce";
import { SEARCH_COMMIT_MAX_WAIT_MILLISECONDS, SEARCH_COMMIT_WAIT_MILLISECONDS } from "src/components/pages/search/constants";

export const debounceSearchCommit = <TArgs extends unknown[]>(callback: (...args: TArgs) => void) =>
    debounce(callback, SEARCH_COMMIT_WAIT_MILLISECONDS, { leading: false, maxWait: SEARCH_COMMIT_MAX_WAIT_MILLISECONDS });
